const ACTION_ITEMS = {
  CANDIDATE_VERIFY: {
    INFO: {
      SET: 'CANDIDATE_VERIFY_INFO_SET',
      ERROR: 'CANDIDATE_VERIFY_INFO_ERROR',
    },
  },
};

export default ACTION_ITEMS;
